export default __webpack_public_path__ + "static/media/021-sardines.73ba8f13.svg";